import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { hyphenateSync } from 'hyphen/is';
import React from 'react';
import { CompactHero } from '../components/hero/CompactHero';

interface IProps {
  title: Prismic.RichText;
  copy: Prismic.RichText;
}

export const CompactHeroContainer = ({ title, copy }: IProps) => {
  return (
    <CompactHero
      title={hyphenateSync(Prismic.text(title) ?? '')}
      description={<PrismicText value={copy} />}
    />
  );
};
